import request from '@/utils/request'
const baseURL = process.env.VUE_APP_BASE_API

export function fetchAssignTaskList(params) {
    return request({
      url: baseURL + '/assignTask/list',
      method: 'GET',
      params: params
    })
  }

export function fetchAssignTaskDetail(param) {
  return request({
    url: baseURL + '/assignTask/detail',
    method: 'GET',
    params: param
  })
}

export function saveAssignTaskData(data) {
  return request({
    url: baseURL + '/assignTask/save',
    method: 'POST',
    data
  })
}
